import ApiClient from './alms-api';
import { Common } from '../core/common';
import { IStringFormat } from '../models/core/system-model';
import { ICreateForumData } from '../models/components/create-forum';
import { IGetForumMessage, ISendForumMessage, IDeleteForum, ISendAnswer, IDeleteMessage } from '../models/action/forum';
import { Log } from 'ng2-logger';
import { MdPanoramaFishEye } from 'react-icons/md';
import { messageAction } from '../store/constants/all';

const token: any = localStorage.getItem('access_token');
let _apiClient: ApiClient;
let _common: Common;
const _logger = Log.create('Forum Service');

export class ForumService {
    constructor() {
        _apiClient = new ApiClient();
        _common = new Common();
    }

    public async RequestGetMyConversationAsync(params: any) {
        return _apiClient.RequestAsync('GET', `api/forum/conversation?take=${params.Take}&skip=${params.Skip}&forumType=${params.Type}&classId=${params.classId}&searchedWord=${encodeURIComponent(params.searchedWord)}&order=${params.Order}&courseId=${params.CourseId}`, null, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetForumthreadByIdAsync(params: string) {
        return _apiClient.RequestAsync('GET', `api/forum/${params}`, null).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetForumMessageAsync(params: IGetForumMessage) {
        return _apiClient.RequestAsync('GET', `api/forum/${params.forumThreadId}/messages?skip=${params.skip.toString()}&take=${params.isAll ? 9999 : params.take.toString()}&searchedWord=${encodeURIComponent(params.searchedWord ? params.searchedWord : '')}`, null).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestAddForum(params: ICreateForumData) {

        let setType = 'POST';
        if (params.forumThreadId) {
            setType = 'PUT';
        }

        const requestParameters = {
            isCommon: params.isCommon,
            selectedClass: params.classIds,
            name: params.subject,
            description: params.body,
            message: params.body,
            courseId: params.courseId,
            hasModerator: params.isModerated,
            forumThreadId: params.forumThreadId
        };

        return _apiClient.RequestAsync(setType, 'api/forum', requestParameters, token).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestSendForumMessage(params: ISendForumMessage) {

        return _apiClient.RequestAsync('POST', 'api/forum/sendmessage', params, token).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestAnswerMessage(params: ISendAnswer) {
        let method = 'POST';
        let url = `api/forum/${params.threadId}/message/${params.messageId}/answer`;
        if (params.isUpdate) {
            method = 'PUT';
            url = `api/forum/${params.threadId}/message/${params.messageId}`;
        }

        return _apiClient.RequestAsync(method, url, params, token).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestDeleteMessage(params: IDeleteMessage) {
        return _apiClient.RequestAsync('DELETE', 'api/forum/' + params.threadId + '/message/' + params.messageId, params, token).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestDeleteForum(params: IDeleteForum) {
        return _apiClient.RequestAsync('DELETE', `api/forum?threadId=${params.forumThreadId}&activityId=${params.activityId!}&classId=${params.classId!}`, null, token).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestAddForumActivityAsync(params: any) {
        let requestMethod = 'POST';
        if (params.activityId) {
            requestMethod = 'PUT';
        }

        return _apiClient
            .RequestAsync(requestMethod, 'api/forum', params, token)
            .then((response: any) => {
                return response;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestGetForumAsync(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/activity/activitylist', params)
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestGetMessageData(params: any) {
        return _apiClient.RequestAsync('GET', `api/forum/${params.threadId}/message/${params.messageId}`, null).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestUpdateMessageData(params: any) {
        return _apiClient.RequestAsync('PUT', `api/forum/${params.threadId}/message/${params.messageId}/updatestatus?isApproved=${params.isApproved}`, null, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetRatingMessage(params: any) {
        return _apiClient.RequestAsync('POST', `api/forum/${params.threadId}/message/${params.messageId}/rating`, params.rating).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

}
